<template>
  <div class="pt-3">
    <div v-if="!loading && dataSet">
      <v-card flat color="rounded_max pa-3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="$router.go(-1)" icon
              ><v-icon>mdi-undo</v-icon></v-btn
            >
          </template>
          <span>Back</span>
        </v-tooltip>
        <div style="min-height: 130px">
          <div class="d-flex align-center">
            <h1 class="mr-3">{{ dataSet.title }}</h1>
            <v-card
              v-if="permissions.includes('LD') || role == 'SUPERADMIN'"
              class="rounded-lg d-flex justify-center align-center"
              @click="updateData()"
              dark
              height="40px"
              width="40px"
              flat
              color="var(--g)"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-card>
          </div>
          <div>
            <p>{{ dataSet.description }}</p>
          </div>
        </div>
        <!-- member -->
        <div>
          <div class="toolbar">
            <v-row no-gutters>
              <v-col cols="10">
                <div class="d-flex pa-2">
                  <v-icon>mdi-magnify</v-icon>
                  <input
                    type="text"
                    class="search_input"
                    placeholder="Search"
                    v-model="find"
                    @keydown="getMember"
                  />
                </div>
              </v-col>
              <v-col cols="2">
                <div class="pa-2">
                  <v-btn
                    block
                    dark
                    class="text-capitalize"
                    color="var(--g)"
                    depressed
                  >
                    Search
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-skeleton-loader
            type="table-tbody"
            v-if="loadMember"
          ></v-skeleton-loader>
          <div v-if="member && !loadMember">
            <v-data-table
              :headers="headers"
              :items="member"
              :page.sync="page"
              :items-per-page="limit"
              class="elevation-0 color_txt"
              hide-default-footer
              :single-select="false"
            >
              <template v-slot:[`item.name`]="{ item }">
                <router-link
                  class="opener_name"
                  :to="`/scholar/${item.user_id}`"
                >
                  <p class="black--text">{{ item.name }}</p>
                  </router-link
                >
              </template>
              <template v-slot:[`item.position`]="{ item }">
                <v-btn
                  small
                  v-if="item.is_leader == 1"
                  depressed
                  color="var(--g)"
                  dark
                  class="text-capitalize"
                >
                  <v-icon class="mr-2">mdi-shield-account</v-icon>
                  Leader
                </v-btn>
                <v-menu
                  :disabled="
                    permissions.includes('LD') || role == 'SUPERADMIN'
                      ? false
                      : true
                  "
                  offset-y
                  nudge-bottom="5px"
                  v-if="item.is_leader == 0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      :disabled="
                        permissions.includes('LD') || role == 'SUPERADMIN'
                          ? false
                          : true
                      "
                      v-bind="attrs"
                      v-on="on"
                      depressed
                      class="text-capitalize"
                    >
                      Member
                      <v-icon class="ml-1">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pa-0">
                    <v-list-item link>
                      <v-list-item-title @click="managePosition(item)">
                        <v-icon class="mr-2">mdi-account-arrow-right</v-icon>
                        Make group leader
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :disabled="
                          permissions.includes('LD') || role == 'SUPERADMIN'
                            ? false
                            : true
                        "
                        color="red"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          permissions.includes('LD') || role == 'SUPERADMIN'
                            ? removeMember(item)
                            : null
                        "
                      >
                        <v-icon> mdi-trash-can-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>Remove user from list</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
            <v-card
              color="#EDF1F0"
              flat
              class="pa-3 mt-5 d-flex align-center justify-end"
            >
              <div class="mr-3 d-flex align-center">
                <p class="default_txt mr-2">ROWS PER PAGE:</p>
                <v-select
                  dense
                  hide-details
                  :items="showData"
                  v-model="limit"
                  @change="getMember"
                  solo
                  flat
                  class="pa-0"
                  color="green"
                  style="width: 100px"
                ></v-select>
              </div>
              <div class="d-flex align-center px-3">
                <v-btn small icon @click="paginate('prev')">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <p class="default_txt mx-3">{{ page }} of {{ last_page }}</p>
                <v-btn small icon @click="paginate('next')">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
      <div class="pa-3">
        <dialog-large
          :d_large="d_large"
          @refetch="fetchData"
          @close="d_large = false"
          :inventory="inventory"
          :type="d_type"
          :title="d_title"
        />
        <dialog-small
          :d_small="d_small"
          @refetch="getMember"
          @close="d_small = false"
          :inventory="inventory"
          :type="d_type"
          :title="d_title"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import dialogLarge from "../dialog/dialogLarge.vue";
import { mapState } from "vuex";
import DialogSmall from "../dialog/dialogSmall.vue";
export default {
  components: { DialogSmall },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  name: "groupDetail",
  data() {
    return {
      dataSet: null,
      loading: false,
      // dialog stuff
      d_large: false,
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",

      // member stuff stuff
      showData: [5, 10, 20],
      find: "",
      page: 1,
      limit: 10,
      total: null,
      isNext: null,
      isPrev: null,
      last_page: null,
      member: null,
      loadMember: false,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: "Full Name",
          align: "start",
          value: "name",
        },
        {
          text: "Email",
          align: "start",
          value: "email",
        },
        { text: "Position", sortable: false, value: "position" },
        { text: "Actions", sortable: false, value: "actions" },
      ],

      // etc
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/course/group?filter[id]=${this.$route.params.idGroup}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataSet = data.data[0];
          this.getMember();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
        });
    },
    paginate(state) {
      if (state == "next" && this.isNext) {
        this.page++;
        this.getMember();
      } else if (state == "prev" && this.isPrev) {
        this.page--;
        this.getMember();
      }
    },
    getMember() {
      this.loadMember = true;
      let data = {
        path: `manage/course/group/member?course_group_id=${this.$route.params.idGroup}&filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.member = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loadMember = false;
          this.isNext = data.next_page_url;
          this.isPrev = data.prev_page_url;
        })
        .catch((err) => {
          this.loadMember = false;
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
        });
    },
    updateData() {
      let member = [];
      if (this.member.length) {
        this.member.forEach((el) => {
          member.push({
            user_id: el.user_id,
            name: el.name,
          });
        });
      }
      this.inventory = {
        member: member,
        group: this.dataSet,
      };
      this.d_type = "u_group";
      this.d_title = "Update Group";
      this.d_large = true;
    },
    managePosition(item) {
      this.inventory = item;
      this.d_type = "m_mgroup";
      this.d_title = "Manage Position";
      this.d_small = true;
    },
    removeMember(item) {
      this.inventory = item;
      this.d_type = "d_mgroup";
      this.d_title = "Remove Member";
      this.d_small = true;
    },
  },
};
</script>

<style>
.search_input {
  padding: 5px 10px 5px 30px;
  border: 2px solid #006341;
  border-radius: 8px;
  width: 100%;
  margin-left: -30px;
}
.search_input:focus {
  outline: #006341;
}
</style>
